import React, { useEffect, useRef } from 'react';
import { Link } from '@/Framework/Router/Next/Link';
import { getCatalogRoute } from '@/finsight/Router/RouteWithRedirect/getNewRoute';
import ICompany from '@/finsight/domain/vo/ICompany';
import { TVirtualBody, useVirtualListContext } from '@dealroadshow/uikit/core/components/Table/VirtualDataTable';

import styles from './catalogItem.scss';

interface IProps {
  data: IData,
  index: number,
  listRef: React.RefObject<TVirtualBody>,
}

interface IData {
  items: ICompany[],
  label: string,
  catalogUrl: string,
}

const CatalogItem = ({ data, index, listRef }: IProps) => {
  const { items, catalogUrl } = data as IData;
  const [ label, values ] = Object.entries(items[index])[0];
  const { setSize } = useVirtualListContext();
  const itemRef = useRef<HTMLDivElement>();

  useEffect(() => {
    const { height = 20 } = itemRef?.current?.getBoundingClientRect();
    setSize(listRef, index, height);
  }, []);

  return (
    <div className={ styles.catalogItem } key={ label } ref={itemRef}>
      <div className={ styles.catalogItemLabel }>{ label }</div>
      <div className={ styles.catalogItemContent }>
        { values.map((item: ICompany) => (
          <p key={ item.viewId }>
            <Link
              to={ getCatalogRoute(catalogUrl, item) }
              title={ item.title }
              target="_blank"
            >
              { item.name }
            </Link>
          </p>
        )) }
      </div>
    </div>
  );
}

export default CatalogItem;
